@let config = (activeForm | async);
@if (config && config.isDirty()) {
  <div class="app-submit-bar">
    <button type="button" class="me-2 rc-cancel-button" kendoButton fillMode="link" (click)="handleCancel(config)">
      {{ "CANCEL" | translate | capitalize }}
    </button>
    @if(config && !(config.hidden?.() ?? false)) {
    <button
      [disabled]="config.isInvalid()"
      kendoButton
      type="button"
      [iconClass]="config.submitIcon()"
      themeColor="primary"
      (click)="config.onSubmit()">
      {{ config.submitLabel() | translate | capitalize }}
    </button>
    }
  </div>
}
